import { constructQuery } from '@repo/shared/helpers';
import { guardedClient as clientRequest } from '@repo/shared/helpers';
import { Task, taskListSchema, taskSchema, TasksApiResponse } from '@repo/shared/domain';

export const getGroupTasks = async (
	groupId: string,
	params?: { page?: number; sort?: string; filter?: string },
): Promise<TasksApiResponse> => {
	const query = constructQuery({
		page: params?.page,
		sort: params?.sort,
		groupId,
		all: params?.filter === 'all' ? 'yes' : '',
	});
	const { body } = await clientRequest.get(`/api/tasks?${query}`, {
		schema: taskListSchema,
	});
	return body;
};

export const getAllGroupTasks = async (groupId: string): Promise<Task[]> => {
	const query = constructQuery({
		groupId,
		all: 'true',
	});
	const { body } = await clientRequest.get(`/api/tasks?${query}`, {
		schema: taskListSchema,
	});
	return body.data;
};

export const getUserTasks = async (
	userId: string,
	params?: { page?: number; sort?: string; filter?: string },
): Promise<TasksApiResponse> => {
	const query = constructQuery({
		page: params?.page,
		sort: params?.sort,
		userId,
		all: params?.filter === 'all' ? 'yes' : '',
	});
	const { body } = await clientRequest.get(`/api/tasks?${query}`, {
		schema: taskListSchema,
	});

	return body;
};

export const getAllUserTasks = async (userId: string): Promise<Task[]> => {
	const query = constructQuery({
		userId,
		all: 'true',
	});
	const { body } = await clientRequest.get(`/api/tasks?${query}`, {
		schema: taskListSchema,
	});
	return body.data;
};

export const getTask = async (taskId: string): Promise<Task | undefined> => {
	try {
		const { body } = await clientRequest.get(`/api/tasks/${taskId}`, {
			schema: taskSchema,
		});
		return body;
	} catch (error) {
		console.error('Failed to get task:', error);
		return undefined;
	}
};
